import React from 'react';
import { useTranslation } from 'react-i18next';

export default function PrivacyPage() {
  const { t } = useTranslation();
  const sections = ['s1', 's2', 's3', 's4', 's5', 's6', 's7', 's8'];
  return (
    <section style={{ padding: '80px 0' }}>
      <div className="container-x" style={{ maxWidth: 860 }}>
        <span className="eyebrow">{t('nav.privacy')}</span>
        <h1 className="font-serif mt-3" style={{ fontSize: 'clamp(30px, 4vw, 44px)', color: 'var(--gd-navy)', letterSpacing: '-0.01em' }}>
          {t('privacy.title')}
        </h1>
        <p style={{ marginTop: 8, color: 'var(--gd-mineral)', fontSize: 13.5 }}>{t('privacy.updated')}</p>
        <div className="hairline" style={{ margin: '28px 0' }} />
        <p style={{ color: '#334155', lineHeight: 1.75 }}>{t('privacy.intro')}</p>
        <div className="legal-prose mt-4">
          {sections.map((s) => (
            <React.Fragment key={s}>
              <h2>{t(`privacy.${s}Title`)}</h2>
              <p>{t(`privacy.${s}Body`)}</p>
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
}
